module.exports = __webpack_public_path__ + "img/map_left_switch.7476777d.svg";